// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contacts-wrapper[data-v-d2669cf0]{background-color:#fff;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;width:calc(100% - 258px);z-index:998}", ""]);
// Exports
module.exports = exports;
